import { navigate } from "../../../plugins/gatsby-plugin-intl-with-root"
import { loadFirebase } from "../../handlers"

export const signOut = async setUser => {
  await loadFirebase().then(f => f.auth().signOut())
  setUser({})
  navigate("/")
}
